import { useState } from "react";
import { useMainContext } from "../../../Context";
import { orders } from "../../../Utils/Apis";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const useOrders = () => {
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    get,
    state: {
      user: { user },
    },
  } = useMainContext();
  const getData = async () => {
    setLoading(true);
    const { data } = await get(
      `${orders}?page=${searchParams.get("page") || 1}`
    );
    setState(data);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, [searchParams]);

  return { state, loading, user };
};
